import { SERVICEURI } from "../const/serviceuri";
import { mapResponseToUserProfile } from "./mapper/userprofilemapper";
import { getFrameworkApiInstance, postFrameworkApiInstance, getFrameworkApiNoAuthInstance, postFrameworkApiNoAuthInstance,
    getBingMapUrlNoAuthInstance
 } from '../instance/fetchframeworkapiInstance';
import { GetAlertsApiInstance } from '../instance/fetchalertsapiInstance';

const getmyProfile = async (userId: string, region: string) => {
    let endPoint = SERVICEURI.GetCurrentUserProfile.replace("{userid}", userId)

    const result = new Promise((onSucess, onFailure) => {
         getFrameworkApiInstance(endPoint).then(response => {
            let userProfile = mapResponseToUserProfile(response, region);
            onSucess(userProfile);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getUserProfile = async (userId: string, region: string) => {
    let endPoint = SERVICEURI.GetUserSignInProfile.replace("{userid}", userId)
    const result =  new Promise((onSucess, onFailure) => {
        getFrameworkApiInstance(endPoint).then(response => {
            let userProfile = mapResponseToUserProfile(response, region);
            onSucess(userProfile);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}


const getUserSignOut = async (userId: string) => {
    let endPoint = SERVICEURI.UserSignOut.replace("{userid}", userId)
    const result =  new Promise((onSucess, onFailure) => {
        getFrameworkApiInstance(endPoint).then(response => {            
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getFCPreferences = async (userAdId: string) => {
    let endPoint = SERVICEURI.getFCPreferences?.replace("{userAdId}", userAdId);
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const postFCPreferences = async (userAdId: string, data: any) => {
    let endPoint = SERVICEURI.postFCPreferences?.replace("{userAdId}", userAdId);
    const result = new Promise((onSucess, onFailure) => {
        postFrameworkApiInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getnotificationcount = async (userId: string) => {
    let endPoint = SERVICEURI.getnotificationcount.replace("{userid}", userId)
    const result = new Promise((onSucess, onFailure) => {
         GetAlertsApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getQuotenotificationcount = async (userId: string) => {
    let endPoint = SERVICEURI.getQuotenotificationcount.replace("{userid}", userId)
    const result = new Promise((onSucess, onFailure) => {
        GetAlertsApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getCountryList = async () => {
    let endPoint = SERVICEURI.getCountryList;
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            const res = response?.length > 0 ? response.map((country: any) => {
                return {
                    ...country, value: country?.country, title: country?.country
                }
            }) : []
            onSucess(res);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getStateList = async (countryCode: any) => {
    let endPoint = SERVICEURI.getStateList.replace("{countryCode}", countryCode);
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            const res = response?.length > 0 ? response.map((state: any) => {
                return {
                    ...state, value: state?.name, title: state?.name, stateCode: state?.id
                }
            }) : []
            onSucess(res);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getCountryFromZip = async (zipCode: any) => {
    let endPoint = SERVICEURI.getCountryFromZip.replace("{zipCode}", zipCode);
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getModalNumberList = async () => {
    let endPoint = SERVICEURI.getModalNumberList;
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            const res = response?.length > 0 ? response.map((model: any) => {
                return {
                    ...model, value: `${model?.name}||${model?.machineTypeId}||${model?.id}`, title: model?.name
                }
            }) : []
            onSucess(res);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getDistributorList = async (modelNumber: any) => {
    let endPoint = SERVICEURI.getDistributorList.replace("{modelId}", modelNumber);
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            const res = response?.length > 0 ? response.map((distributor: any) => {
                return {
                    ...distributor, value: distributor?.name, title: distributor?.name
                }
            }) : []
            onSucess(res);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getJobTitleList = async () => {
    let endPoint = SERVICEURI.getJobTitleList;
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            const res = response?.length > 0 ? response.map((jobTitle: any) => {
                return {
                    ...jobTitle, value: jobTitle?.name, title: jobTitle?.name
                }
            }) : [];
            onSucess(res);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const checkDistributorAvailability = async (data: any) => {
    let endPoint = SERVICEURI.checkDistributorAvailability;
    const result = new Promise((onSucess, onFailure) => {
        postFrameworkApiNoAuthInstance(endPoint, data).then((response: any) => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const getAddressList = async (searchKey: any, userCircularMapView: any) => {
    let endPoint = SERVICEURI.getAddressList.replace("{searchKey}", searchKey);
    endPoint = userCircularMapView?  endPoint.replace('{userCircularMapView}', userCircularMapView) : endPoint.replace('&userCircularMapView={userCircularMapView}', '');
    const result = new Promise((onSucess, onFailure) => {
        getBingMapUrlNoAuthInstance(endPoint).then((response: any) => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;

}

const submitUserRegistration = async (data: any) => {
    let endPoint = SERVICEURI.submitUserRegistration;
    const result = new Promise((onSucess, onFailure) => {
        postFrameworkApiNoAuthInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const sendNotification = async (data: any) => {
    let endPoint = SERVICEURI.sendNotification;
    const result = new Promise((onSucess, onFailure) => {
        postFrameworkApiNoAuthInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

const checkSerialModelMapping = async (data: any) => {
    let endPoint = SERVICEURI.checkSerialModelMapping.replace("{serialNumber}", data.serialNumber).replace("{model}", data.model);
    const result = new Promise((onSucess, onFailure) => {
        getFrameworkApiNoAuthInstance(endPoint).then((response: any) => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await result;
}

export default {
    getmyProfile, getUserProfile, getUserSignOut, getFCPreferences, postFCPreferences, getnotificationcount, getQuotenotificationcount,
    getCountryList, getStateList, getCountryFromZip, getModalNumberList, getDistributorList, getJobTitleList,
    checkDistributorAvailability, getAddressList, submitUserRegistration, sendNotification, checkSerialModelMapping
}
